module.exports = __webpack_public_path__ + "img/bg.9505e370.jpg";